import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

/******************* Configuración de Firebase *******************/
var firebase = require("firebase/app");

// agregamos los servicios adicionales
require("firebase/auth");
require("firebase/firestore");

// Configuración de Firebase
var config = {
  apiKey: "AIzaSyDAGljOa0aKmynsaCmgKIuUH7Sk7yFOv4I",
  authDomain: "crud-vue-e911a.firebaseapp.com",
  databaseURL: "https://crud-vue-e911a.firebaseio.com",
  projectId: "crud-vue-e911a",
  storageBucket: "crud-vue-e911a.appspot.com",
  messagingSenderId: "741106775568",
  appId: "1:741106775568:web:e51474ad34c167badebc95"
};

// Initializa Firebase
const firebaseApp = firebase.initializeApp(config);

firebaseApp.firestore();

export default firebaseApp.firestore();
/******************* Fin configuración de Firebase *******************/

/******************* Configuración de Bootstrap *******************/
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
/******************* Fin configuración de Bootstrap *******************/

/******************* Configuración de Vue Validate *******************/
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)
/***************** Fin configuración de Vue Validate *****************/

Vue.config.productionTip = false

firebase.auth().onAuthStateChanged((user) => {
  //console.log(user);
  if (user) {
    // invoca a una acción del store
    store.dispatch('detectarUsuario', {email: user.email, uid: user.uid});
  } else {
    // invoca a una acción del store
    store.dispatch('detectarUsuario', null);
  }

  /* este código se ha movido hacia este punto porque sino la aplicación hace las validaciones
     antes de que firebase responda y eso genera que cada vez que se actualice la aplicación
     este regrese a la página por default que en este caso es "Ingreso"
  */
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')

});
